<template>
  <b-modal
    id="modal-package"
    hideHeader
    hideHeaderClose
    hideFooter
    noCloseOnBackdrop
    noCloseOnEsc
    size="md"
  >
    <div class="custom-modal-body container p-0">
      <Package
        v-if="currentPackage"
        :packageKey="packageItem.packageKey"
        :title="packageItem.title"
        :appIcon="packageItem.appIcon"
        :appColor="packageItem.appColor"
        :masterPriceList="packageItem.masterPriceList"
        :apps="packageItem.apps"
        :isFocus="packageItem.isFocus"
        :isShowInfo="false"
        :isShowBackHomeButton="true"
        :advancedTableRows="packageItem.advancedTableRows"
        :addOnTableRows="packageItem.addOnTableRows"
        :channelTableRows="packageItem.channelTableRows"
        :payButtonText="packageItem.payButtonText"
        :payButtonClass="packageItem.payButtonClass"
        class="custom-package"
        @onSubmit="handleSubmit"
      />
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import packageMixin from '../../mixins/package'
import Package from '../custom/Package.vue'
import moment from 'moment/moment'

export default {
  mixins: [packageMixin],

  components: {
    Package,
  },

  // props: {
  //   packageKey: String,
  // },

  data() {
    return {
      packageKey: null,
    }
  },

  computed: {
    ...mapGetters({
      getAppCurrent: 'getAppCurrent',
      isFreeTrialLive: 'isFreeTrialLive',
      shopInfo: 'getShopInfo',
    }),
    currentPackage() {
      return this.packages.find((item) => item.checkAlertModalPackageAppIds.includes(this.getAppCurrent.app_id))
    },
    packageItem() {
      return this.mapPackages.find((item) => item.packageKey === this.currentPackage.packageKey)
    },
    isPricingPackage() {
      return this.shopInfo.pricing.type == 'package'
    },
  },

  methods: {
    checkToOpenModalPackage() {
      if (this.currentPackage) {
        if (!this.isValid(this.currentPackage.appId, this.currentPackage.packageKey)) {
          this.$bvModal.show('modal-package')
        }
      }
    },
    getPackageInfo(packageKey) {
      const packageItem = this.currentPackageRows.find((item) => item.packageKey === packageKey)
      return packageItem
    },
    isValid(appId, packageKey) {
      if (!this.isPricingPackage) {
        return true
      }

      if (this.isFreeTrialLive) {
        return true
      }

      const packageInfo = this.getPackageInfo(packageKey)
      if (packageInfo) {
        if (packageInfo.isPermanent) {
          return true
        }
        const diffDays = moment(packageInfo.expiredAtDate).diff(moment(), 'days')
        if (diffDays > 0) {
          return true
        }
      }

      return false
    },
  },

  watch: {
    $route(to, from) {
      this.$nextTick(() => {
        this.checkToOpenModalPackage()
      })
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.checkToOpenModalPackage()
    })
  },
}
</script>

<style scoped>
.custom-package {
  border: none !important;
}

* /deep/ .modal-body {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseModalPackage.vue